import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "KATEGÓRIE", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, { to: "/mod-stock/categories/0" }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať kategóriu",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "uppercase"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DataTable, {
        scrollable: "",
        scrollHeight: `${this.vh - 290}px`,
        value: this.categories,
        stripedRows: "",
        "row-hover": "",
        selection: this.selectedCategory,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedCategory) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[1] || (_cache[1] = ($event: any) => ($options.editCategory(this.selectedCategory.id))),
        tableStyle: "width: 100%",
        virtualScrollerOptions: { itemSize: 40 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: "Názov",
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Popis",
            style: {"min-width":"60%"}
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-pencil",
                onClick: ($event: any) => ($options.editCategory(slotProps.data.id)),
                text: "",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Editácia kategórie' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                onClick: ($event: any) => ($options.deleteCategory(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["scrollHeight", "value", "selection"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}